<template>
  <div>
    FAQ
  </div>
</template>

<script>
export default {
  name: "FAQView"
}
</script>

<style scoped>

</style>